export function rarityScheme(selectedPct) {
  const data = {
    unique: {
      id: "unique",
      level: 9,
      class: "unique dark",
      word: "Unique",
      emoji: "🔮",
      toolTip: null,
      dark: true,
      emojiSquare: "🔮",
    },
    legendary: {
      id: "legendary",
      level: 7,
      class: "legendary",
      word: "Legendary",
      emoji: "✨",
      toolTip: "Selected by less than 2% of BikeGrid players.",
      dark: true,
      emojiSquare: "🟪",
    },
    epic: {
      id: "epic",
      level: 5,
      class: "epic",
      word: "Epic",
      emoji: "✨",
      toolTip: "Selected by between 2-5% of BikeGrid players.",
      dark: false,
      emojiSquare: "🟦",
    },
    rare: {
      id: "rare",
      level: 3,
      class: "rare",
      word: "Rare",
      emoji: "✨",
      toolTip: "Selected by between 5-10% of BikeGrid players.",
      dark: false,
      emojiSquare: "🟨",
    },
    common: {
      id: "common",
      level: 1,
      class: "common",
      word: "Common",
      emoji: null,
      toolTip: null,
      dark: false,
      emojiSquare: "🟩",
    },
  };

  if (selectedPct <= 0.1) {
    return data["unique"];
  } else if (selectedPct <= 2) {
    return data["legendary"];
  } else if (selectedPct <= 5) {
    return data["epic"];
  } else if (selectedPct <= 10) {
    return data["rare"];
  }

  return data["common"];
}
